import { SET_HEADER_ADVANCED_SEARCH_PARAMS, SET_HEADER_BUTTON_PARAMS, SET_HEADER_TEXT } from "../actions/action_types";

export default function headerReducer(state = { name: '', link: '', bgColor: '', hoverColor: '', headerText: '', parameters: [] }, action) {
    switch (action.type) {
        case SET_HEADER_BUTTON_PARAMS:
            return {...action.payload, headerText: state.headerText }
        case SET_HEADER_TEXT:
            return {...state, headerText: action.payload }
        case SET_HEADER_ADVANCED_SEARCH_PARAMS:
            return {...state, parameters: action.payload }
        default:
            return state
    }
}